import React from 'react';
import '../Styles/SliderBTN.css';

const SliderBTN = ({ onPrev, onNext }) => {
  return (
    <div className="SliderBTN-nav">
      <button onClick={onPrev} className="SliderBTN">&#8592;</button>
      <button onClick={onNext} className="SliderBTN">&#8594;</button>
    </div>
  );
};

export default SliderBTN;
